<template>
  <div class="box-father" v-loading="exportLoading">
    <div style="height: 100%">
      <div class="box-header">
        <div class="box-header-left">
          <div class="box-header-left-text">工作日记&nbsp;/&nbsp;</div>
          <div class="box-header-right">
            <div>工作日记</div>
          </div>
        </div>
      </div>
      <div class="section">
        <div class="biaodan2">
          <div class="biaodan-left">
            <div style="height: 100%; width: 100%">
              <el-form
                :inline="true"
                label-position="left"
                class="demo-form-inline"
                :model="form"
              >
                <el-form-item label="日期">
                  <el-date-picker
                    v-model="form.dayStr"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择时间"
                    :clearable="false"
                    @change="onSearch"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="事项名称">
                  <el-input
                    v-model="form.eventName"
                    clearable
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="事项类型">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.eventType"
                  >
                    <el-option
                      v-for="item in sxTypeList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="事项状态">
                  <el-select
                    filterable
                    placeholder="请选择"
                    clearable
                    v-model="form.state"
                  >
                    <el-option
                      v-for="item in sxStatusList"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="提交人">
                  <el-select
                    v-model="form.userId"
                    filterable
                    remote
                    clearable
                    reserve-keyword
                    placeholder="支持输入模糊和下拉选择"
                    :remote-method="remoteMethod"
                    :loading="loading">
                    <el-option
                      v-for="item in userList"
                      :key="item.id"
                      :label="item.userName"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item class="form-item">
                  <el-button @click="onSearch" class="search">查询</el-button>
                  <el-button class="reset" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="aside">
          <div class="table-top-btns">
            <div class="left-btn"></div>
            <div class="right-btn">
              <el-button
                @click="dialogVisible2 = true"
                icon="el-icon-download"
                class="search"
                >导出事项</el-button
              >
            </div>
          </div>
          <common-table
            :select="false"
            :page="page"
            :dataList="dataList"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            :maxHeight="640"
            :isShowPagination="false"
          >
            <template v-slot:submitFlag="{ scope }">
              <span>{{ !scope.row.submitFlag ? '未提交' : '已提交' }}</span>
            </template>
            <template v-slot:extendDutyTimes="{ scope }">
              <span>{{ extendDuty[scope.row.extendDutyTimes] }}</span>
            </template>
            <template v-slot:operation="{ scope }">
              <el-button
                @click="qusetionDetail(scope.row)"
                style="font-size: 16px"
                type="primary"
                :disabled="!!scope.row.fileJson ? false : true"
                >查看图片</el-button
              >
            </template>
          </common-table>
        </div>
      </div>
    </div>

    <el-dialog
      title="导出事项"
      :visible.sync="dialogVisible2"
      width="600px"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div class="container-dialog">
        <el-form
          :inline="true"
          label-position="left"
          class="demo-form-inline"
          :model="exportForm"
          ref="demoref"
        >
          <el-form-item
            label="导出日期"
            prop="valueTime"
          >
            <el-date-picker
              v-model="exportForm.valueTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        
          <el-form-item  label="导出维度">
            <el-select
              filterable
              placeholder="请选择导出维度"
              v-model="exportForm.searchSource"
            >
              <el-option
                v-for="item in actionsTwo"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button
          type="primary"
          @click="dutyWordExp"
          :loading="exportLoading"
          >导 出</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="查看图片" :visible.sync="dialogTableVisible" width="60%" style="margin-top: 10vh;">
      <el-carousel indicator-position="outside" height="500px" arrow="always">
        <el-carousel-item v-for="(items, indexs) in currentItem.fileJson" :key="indexs" style="display: flex;justify-content: center;">
          <img :src="items.url" style="height: 100%;">
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
  </div>
</template>

<script>
import {
  dayDutyList,
  dutyWordExp,
  authUserlist,
  authUserDeptList
} from "@/api/task.js";
import commonTable from "@/components/table/index.vue";
import moment from "moment";
export default {
  components: {
    commonTable
  },
  data() {
    return {
      loading: false,
      dialogTableVisible: false,
      currentItem: {},
      dialogVisible2: false,
      exportLoading: false,
      exportForm: {
        createTimeEnd: "",
        createTimeStart: "",
        searchSource: "",
        valueTime: [],
        eventType: "",
        state: "",
      },
      actionsTwo: [],
      form: {
        eventType: "",
        eventName: "",
        userId: "",
        state: "",
        dayStr: moment(new Date()).format("YYYY-MM-DD")
      },
      page: {
        size: 10,
        page: 1,
        total: 0
      },
      dataList: {
        tableData: [],
        columns: [
          {
            prop: "createTime",
            label: "日期",
            width: "200px"
          },
          {
            prop: "username",
            label: "上报人",
          },
          {
            prop: "eventType",
            label: "事项类型",
          },
          {
            slot: "extendDutyTimes",
            label: "事项周期",
          },
          {
            prop: "eventName",
            label: "事项名称",
          },
          {
            prop: "state",
            label: "事项状态",
          },
          {
            prop: "rangeHourTime",
            label: "工作时段",
          },
          {
            prop: "workContent",
            label: "工作说明",
          },
          {
            slot: "submitFlag",
            label: "当日提交状态",
          },
          {
            prop: "submitTime",
            label: "提交时间",
          },
          {
            slot: "operation",
            label: "操作",
          }
        ]
      },
      formInfo: [
        // {
        //   text: '事项名称',
        //   key: 'eventName'
        // },
        // {
        //   text: '日期',
        //   key: 'createTime'
        // },
        // {
        //   text: '事项类型',
        //   key: 'eventType'
        // },
        // {
        //   text: '事项周期',
        //   key: 'extendDutyTimes'
        // },
        // {
        //   text: '事项状态',
        //   key: 'state'
        // },
        // {
        //   text: '工作时段',
        //   key: 'rangeHourTime'
        // },
        // {
        //   text: '当日提交状态',
        //   key: 'submitFlag'
        // },
        // {
        //   text: '提交人',
        //   key: 'username'
        // },
        // {
        //   text: '提交时间',
        //   key: 'submitTime'
        // },
        // {
        //   text: '工作说明',
        //   key: 'workContent'
        // },
        {
          text: '',
          key: 'fileJson'
        }
      ],
      userList: [],
      userListDefault: [],
      exportLoading: false,
      sxTypeList: [
        {
          text: "个人事项",
          value: "个人事项",
        },
        {
          text: "部门事项",
          value: "部门事项",
        },
        {
          text: "额外事项",
          value: "额外事项",
        },
      ],
      sxStatusList:[
        {
          text: "未开始",
          value: "未开始",
        },
        {
          text: "进行中",
          value: "进行中",
        },
        {
          text: "已完成",
          value: "已完成",
        },
      ],
      extendDuty: {
        "S1_DAY": "每日",
        "S2_WEEK": "每周",
        "S3_MONTH": "每月",
        "S4_YEAR": "每年",
      }
    };
  },
  mounted() {
    this.getUserList();
    this.getPointTypeListPageFun();
    let userInfo = sessionStorage.getItem('userInfo') ? JSON.parse(sessionStorage.getItem('userInfo')) : null;
    const roles = userInfo && userInfo.roles && userInfo.roles.length
			? userInfo.roles.map((item) => item.roleCode)
			: [];
		this.handleRoles(roles);
  },
  methods: {
    // 详情
    qusetionDetail (row) {
      this.currentItem = row;
      this.$set(this.currentItem, 'fileJson', row.fileJson ? (Array.isArray(row.fileJson) ? row.fileJson : JSON.parse(row.fileJson)) : []);
      this.dialogTableVisible = true;
    },
    // 提交人
    async remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
          let params = {
            size: 100,
            page: 1,
            keyword: query,
          };
          authUserlist(params).then((res) => {
            this.userList = res.data.data.records;
          });
        }, 200);
      } else {
        this.userList = this.userListDefault;
      }
    },
    // 获取部门资源树形
    async getUserList(query = '') {
      let params = {
        size: 100,
        page: 1,
        keyword: query,
      };
      authUserlist(params).then((res) => {
        this.userList = res.data.data.records;
        this.userListDefault = res.data.data.records;
      });
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getPointTypeListPageFun();
    },
    handleCurrentChange(val) {
      this.page.page = val;
      this.getPointTypeListPageFun();
    },

    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    onReset() {
      this.form.eventName = "";
      this.form.eventType = "";
      this.form.state = "";
      this.form.userId = "";
      this.form.dayStr = moment(new Date()).format("YYYY-MM-DD");
      this.page.page = 1;
      this.page.size = 10;
      this.getPointTypeListPageFun();
    },
    async handleRoles(roles) {
			if (roles.includes("GLLD") || roles.includes("GZRJ_GLY")) {
				this.actionsTwo = [
					{
						text: "全部",
						value: "全部",
					},
					{
						text: "自己",
						value: "自己",
					},
				];
				this.exportForm.searchSource = "全部";
			}
			let { data } = await authUserDeptList({notEndStr: "网格"})
				if (data.code == 200) {
				this.actionsTwo = [...this.actionsTwo, ...data.data.map(item  => {
					return {
						text: item.deptName,
						value: item.deptCode,
						deptCode: item.deptCode
					}
				})]
			}
		},
    async dutyWordExp () {
      this.exportLoading = true;
      let res = await dutyWordExp({
        createTimeStart: this.exportForm.valueTime && this.exportForm.valueTime.length ? `${this.exportForm.valueTime[0]} 00:00:00` : '',
        createTimeEnd: this.exportForm.valueTime && this.exportForm.valueTime.length ? `${this.exportForm.valueTime[1]} 23:59:59` : '',
        searchSource: this.exportForm.searchSource,
        eventType: this.form.eventType,
        state: this.form.state,
      });
      if (res.status == 200) {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "工作日记事项" + new Date().getTime() + ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
      }
      this.exportLoading = false;
    },
    // 分页查询
    async getPointTypeListPageFun() {
      let params = {
        ...this.form,
        page: this.page.page,
        size: this.page.size
      };
      const res = await dayDutyList(params);
      if (res.data.code == 200) {
        this.dataList.tableData = res.data.data
          ? res.data.data
          : [];
        this.page.total = res.data.data.length;
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "~@/components/less.less";

.biaodan2 {
  width: 100%;
  margin-top: 1px;
  display: block;

  .form-item {
    padding: 0;
    margin: 0;
  }
}

.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.demo-form-inline {
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
}

.section .el-form-item__label {
  text-align: left;
}

.el-button {
  height: 40px;
  font-size: 16px;
}

.table-header {
  height: 56px;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

/deep/.el-pagination .el-input--mini .el-input__inner,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .el-pager li,
/deep/.el-pagination__jump .el-input__inner {
  height: 32px;
  line-height: 32px;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border-radius: 4px;
  border: 1px solid #0495ff;
  color: #0495ff;
  background: none;
}

/deep/.el-pagination__jump {
  margin-left: 0;
}

.tuihui {
  color: #eb3538;
  font-size: 16px;
}

.fileJson {
  img {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

/deep/ .el-carousel__arrow {
  width: 54px !important;
  height: 54px !important;
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/gzrj/index.vue